import React, { Component } from 'react';
import PropTypes from 'prop-types';

import widgetWrapper from './widgetWrapper';

import { formatTimestamp } from './widgetUtils';

import './TextWidget.scss';

class TextWidget extends Component {

  static propTypes = {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    details: PropTypes.string,
    value: PropTypes.string.isRequired,
    timestamp: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
  };

  static defaultProps = {
    title: '',
    subtitle: '',
    details: '',
    timestamp: '',
    className: '',
  };

  render() {
    const {
      title,
      subtitle,
      details,
      value,
      timestamp,
      className,
    } = this.props;
    return (
      <div className={`widget-threshold-colors TextWidget ${className}`}>
        <div className="header">
          <div className="title">{title}</div>
          <div className="subtitle">{subtitle}</div>
        </div>
        <div className="content">
          <div className="value">{value}</div>
        </div>
        <div className="footer">
          <div className="details">{details}</div>
          <div className="timestamp">{formatTimestamp(timestamp)}</div>
        </div>
      </div>
    );
  }
}

export default widgetWrapper(TextWidget);
